export const promote = (config) => ({
    ...config,
    includeAttachments: false
});
//# sourceMappingURL=smtp-send-email-1-to-2.js.map